import { cx } from "../../lib/cx.js";
import { formatDate } from "../../lib/format.js";
import { Popover } from "../Popover/Popover.js";
/* empty css                 */
import { jsx } from "react/jsx-runtime";
//#region src/components/PayDatesChip/PayDatesChip.tsx
/**
* An upload's pay dates in a table cell: the date itself when there's one, or a chip
* ("3 pay dates") that opens a popover listing them (the By-upload table).
*/
function PayDatesChip({ dates, format = (date) => formatDate(date), maxInline = 1, label = (count) => `${count} pay dates`, defaultOpen = false, className, ...rest }) {
	const formatted = dates.map(format);
	if (formatted.length === 0) return /* @__PURE__ */ jsx("span", {
		...rest,
		className: cx("ds-pay-dates", className),
		children: "—"
	});
	if (formatted.length <= maxInline) return /* @__PURE__ */ jsx("span", {
		...rest,
		className: cx("ds-pay-dates", className),
		children: formatted.join(", ")
	});
	return /* @__PURE__ */ jsx("span", {
		...rest,
		className: cx("ds-pay-dates", className),
		children: /* @__PURE__ */ jsx(Popover, {
			"aria-label": "Pay dates",
			placement: "bottom-start",
			defaultOpen,
			trigger: /* @__PURE__ */ jsx("button", {
				type: "button",
				className: "ds-pay-dates__chip",
				children: label(formatted.length)
			}),
			children: /* @__PURE__ */ jsx("ul", {
				className: "ds-pay-dates__list",
				children: formatted.map((date, index) => /* @__PURE__ */ jsx("li", { children: date }, `${date}-${index}`))
			})
		})
	});
}
//#endregion
export { PayDatesChip };

//# sourceMappingURL=PayDatesChip.js.map